/* eslint-disable */

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueSignaturePad from 'vue-signature-pad';
import moment from 'moment';
import {
  PiniaVuePlugin
} from 'pinia'

import vuetify from './plugins/vuetify'
import PermissionGate from '@/components/PermissionGate.vue';

import pinia from './pinia';

function getBuildVersion() {
  const meta = document.querySelector('meta[name="app-version"]');

  return meta?.content || process.env.VUE_APP_VERSION || 'dev';
}

function ensureFreshBuild() {
  const currentVersion = getBuildVersion();
  const storedVersion = localStorage.getItem('spa_build_version');

  if (storedVersion && storedVersion !== currentVersion) {
    // Clear app-level cached state so a freshly deployed SPA does not keep
    // stale feature flags, permissions, or settings from the previous build.
    [
      'feature_modules',
      'feature_flags',
      'permissions',
      'role',
      'settings',
    ].forEach((key) => localStorage.removeItem(key));
  }

  localStorage.setItem('spa_build_version', currentVersion);
}

ensureFreshBuild();

Vue.use(PiniaVuePlugin)
Vue.config.productionTip = false;
Vue.use(VueSignaturePad);
Vue.prototype.moment = moment;
Vue.component('PermissionGate', PermissionGate);


export const eventBus = new Vue();

new Vue({
  pinia,
  router,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
